import React from 'react';
import { Typography } from '@mui/material';
import MLButton from '../Button/Button';
import MLLoader from '../Loader/Loader';

const UpdatingVersion = ({
  message = 'Updating to latest version of App',
  includeBtn = false,
  btnText = 'Button',
  onBtnClick = () => {},
  classList = '',
  iconFill = 'var(--Orange-100)',
}) => {
  return (
    <div
      className={`w-full h-full flex items-center justify-center bg-[var(--Grey-10)] no-data-wrap ${classList}`}
    >
      <div className="flex flex-col items-center justify-center gap-6">
        <MLLoader />
        <Typography variant="h5">{message}</Typography>
        {includeBtn && (
          <MLButton
            btnText={btnText}
            onClickFunc={onBtnClick}
            btnSize="medium"
          />
        )}
      </div>
    </div>
  );
};

export default UpdatingVersion;
